import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import NavBar from '../components/nav';
import { Footer } from '../components/footer';
import PageBanner from '../components/PageBanner';
import { FaHome, FaFileContract, FaCreditCard, FaUsers, FaStar } from 'react-icons/fa';

export default function TermsOfService() {
  const { t } = useTranslation();
  return (
    <>
      <NavBar />
      <div className="min-h-screen bg-gray-50">
        {/* Breadcrumb */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-4">
          <nav className="flex items-center space-x-2 text-sm text-gray-600 mb-6">
            <Link to="/" className="flex items-center hover:text-green-600 transition-colors">
              <FaHome className="w-4 h-4 mr-1" />
              {t('terms.home')}
            </Link>
            <span className="text-gray-400">/</span>
            <span className="text-gray-900 font-medium">{t('terms.breadcrumb')}</span>
          </nav>
        </div>

        <PageBanner />

        {/* Header Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">
              {t('terms.title')}
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              {t('terms.subtitle')}
            </p>
          </div>

          {/* Main Content */}
          <div className="max-w-4xl mx-auto">
            {/* Introduction */}
            <section className="bg-white rounded-2xl p-8 mb-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center mr-4">
                  <FaFileContract className="text-white text-xl" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">{t('terms.s1Title')}</h2>
              </div>
              <div className="space-y-6 text-gray-700">
                <h3 className="text-lg font-semibold text-gray-900">{t('terms.s1aTitle')}</h3>
                <p className="leading-relaxed">{t('terms.s1aText1')}</p>
                <p className="leading-relaxed">{t('terms.s1aText2')}</p>
                <p className="leading-relaxed">{t('terms.s1aText3')}</p>
              </div>
            </section>

            {/* Partners Section */}
            <section className="bg-white rounded-2xl p-8 mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">{t('terms.s1bTitle')}</h3>
              <div className="space-y-6 text-gray-700">
                <p className="leading-relaxed">{t('terms.s1bText1')}</p>
                <p className="leading-relaxed">{t('terms.s1bText2')}</p>
                <p className="leading-relaxed">{t('terms.s1bText3')}</p>
              </div>
            </section>

            {/* Delivery Partners */}
            <section className="bg-white rounded-2xl p-8 mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">{t('terms.s1cTitle')}</h3>
              <div className="space-y-6 text-gray-700">
                <p className="leading-relaxed">{t('terms.s1cText1')}</p>
                <p className="leading-relaxed">{t('terms.s1cText2')}</p>
                <p className="leading-relaxed">{t('terms.s1cText3')}</p>
              </div>
            </section>

            {/* Cancellation Rights */}
            <section className="bg-white rounded-2xl p-8 mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">{t('terms.s1dTitle')}</h3>
              <div className="space-y-6 text-gray-700">
                <p className="leading-relaxed">{t('terms.s1dText1')}</p>
                <p className="leading-relaxed">{t('terms.s1dText2')}</p>
              </div>
            </section>

            {/* Payment Methods */}
            <section className="bg-white rounded-2xl p-8 mb-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center mr-4">
                  <FaCreditCard className="text-white text-xl" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">{t('terms.s1gTitle')}</h2>
              </div>
              <div className="space-y-6 text-gray-700">
                <p className="leading-relaxed">{t('terms.s1gText1')}</p>
                <p className="leading-relaxed">{t('terms.s1gText2')}</p>
                <p className="leading-relaxed">{t('terms.s1gText3')}</p>
              </div>
            </section>

            {/* Disputes and Customer Service */}
            <section className="bg-white rounded-2xl p-8 mb-8">
              <h3 className="text-lg font-semibold text-gray-900 mb-4">{t('terms.s1hTitle')}</h3>
              <div className="space-y-6 text-gray-700">
                <p className="leading-relaxed">{t('terms.s1hText1')}</p>
                <p className="leading-relaxed">{t('terms.s1hText2')}</p>
              </div>
            </section>

            {/* Rating System */}
            <section className="bg-white rounded-2xl p-8 mb-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center mr-4">
                  <FaStar className="text-white text-xl" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">{t('terms.s2Title')}</h2>
              </div>
              <div className="space-y-6 text-gray-700">
                <p className="leading-relaxed">{t('terms.s2Text1')}</p>
                <p className="leading-relaxed">{t('terms.s2Text2')}</p>
              </div>
            </section>

            {/* Innovation */}
            <section className="bg-white rounded-2xl p-8">
              <div className="flex items-center mb-6">
                <div className="w-12 h-12 bg-green-600 rounded-xl flex items-center justify-center mr-4">
                  <FaUsers className="text-white text-xl" />
                </div>
                <h2 className="text-2xl font-bold text-gray-900">{t('terms.s3Title')}</h2>
              </div>
              <div className="space-y-6 text-gray-700">
                <p className="leading-relaxed">{t('terms.s3Text1')}</p>
                <p className="leading-relaxed">{t('terms.s3Text2')}</p>
                <p className="leading-relaxed">{t('terms.s3Text3')}</p>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}
